import script from "./PageCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageCard.vue?vue&type=script&lang=ts&setup=true"

import "./PageCard.vue?vue&type=style&index=0&id=2fb0eb1a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fb0eb1a"]])

export default __exports__